import { Route, Switch } from 'react-router-dom';
import PropTypes from 'prop-types';
import { useLoadComponent } from '@yooink/youtils/es/hooks/useLoadComponent';

const MaintainceScriptsRoute = (props) => {
	const basePath = props.path || '/system/maintenanceScripts';
	const getPath = (path = '') => `${basePath}${path}`;

	const List = useLoadComponent(() => import('./List'), {
		basePath
	});
	const View = useLoadComponent(() => import('./View'), {
		basePath
	});
	const ViewWithEventStream = useLoadComponent(() => import('./ViewWithEventStream').then(m => m.ViewWithEventStream), {
		basePath
	});

	return (
		<>
			<Route
				exact
				path={getPath()}
				component={List}
			/>
			<Switch>
				<Route
					exact
					path={getPath('/:id')}
					component={View}
				/>
				<Route
					exact
					path={getPath('/:id/es')}
					component={ViewWithEventStream}
				/>
			</Switch>
		</>
	);
};

MaintainceScriptsRoute.propTypes = {
	path: PropTypes.string
};

export { MaintainceScriptsRoute };
